<div
  class="form-message"
  *ngIf="show"
  [ngClass]="{
    'info': type === 'info',
    'error': type === 'error',
    'success': type === 'success',
    'visible': show
  }">
  <ng-content></ng-content>
</div>
